import { mapState } from 'vuex';
import f from '@/application/shared/functions';

export default {
    name: 'catalog',
    props: {
        locale : String,
        age : Number | String,
        initial : ''
    },

    data : function(){

        return {
            loading : true,
            error : null,
            level : '',
            defaultLevel : 'catalog',
            emoji : [
                "🎈","🎉","🥳","🎊","🎀","🎁","🎎","🎏","🎐",
                "🎇","🎆","🎭","🎨","🖍️","🧩","🧸","🪀",
                "🪁","🏮","🪔","✨","⭐","🌟","💫","💎","🔮",
                "🎶","🎵","🎼","📯","🥁","🎺","🎷","🎸","🎻","🎹",
                "🎲","🧿","⚽","🏀","🏐","🏓","🥏","🎳",
            ],
        }

    },

    created () {

        this.load().then(() => {

            var nl = _.filter([this.defaultLevel, this.initial || ''], (l) => {
                return l
            }).join('.')

            var item = f.deep(this.catalog, nl)

            console.log('item', item)

            if(!item){
                this.level = this.defaultLevel
            }
            else{
                if(this.final(item)){
                    nl = this.composebacklevel(nl)
                }

                this.level = nl
            }

        })
    },

    watch: {
        //$route: 'getdata'
    },
    computed: mapState({
        auth : state => state.auth,
    }),

    methods : {
        deep : function(c, l){
            return f.deep(c, l)
        },
        getrandomemoji : function(){
            return this.emoji[f.rand(0, this.emoji.length - 1)]
        },
        load : function(){

            this.loading = true

            return this.core.api.lessons.catalog({locale : this.locale, age : this.age}).then((catalog) => {
                this.catalog = catalog
            }).catch(e => {
                console.error(e)
                this.error = e
            }).finally(() => {
                this.loading = false
            })
        },

        final : function(item){
            if(!_.isObject(item)) return true
        },

        composeLevel : function(i){
            return this.level + '.' + i
        },

        composebacklevel : function(level){
            var levels = level.split('.')

            return _.first(levels, levels.length - 1).join('.')
        },

        keyfunc : function(i){
            return f.sha224(i).toString()
        },

        back : function(){
            this.level = this.composebacklevel(this.level)
        },

        clickItem : function(i){

            var nl = this.composeLevel(i)

            var item = f.deep(this.catalog, nl)

            if(this.final(item)){
                this.gotolevel(nl)
            }
            else{
                this.level = nl
            }
        },

        gotolevel : function(nl){

            var cl = _.filter((nl || this.level).split('.'), l => {
                return l != this.defaultLevel
            }).join('.')

            this.$emit("apply", cl)

            this.$emit('close')
        },

        cancel : function(){
            this.$emit('close')
        }
    },
}